import styled from 'styled-components';
import { colors } from '@womcorp/wom-miwom-ui-kit/dist/@theme/colors';
import { ReactComponent as LogoWom } from '../../../../images/purple-logo.svg';

const CleanLayoutStyled = styled.section`
  background: #ffffff;
  min-height: 100vh;
  width: 100%;

  & > aside {
    height: 6px;
    background: ${colors.GradientesAlphaH};
  }
  & > header {
    padding: 52px;
    text-align: center;
  }

  @media screen and (min-width: 769px) {
    & > header {
      padding: 60px;
    }
  }
`;

const LogoWomStyled = styled(LogoWom)`
  @media screen and (max-width: 768px) {
    transform: scale(74.28%);
  }
`;

export default CleanLayoutStyled;

export { LogoWomStyled };
